<p-toast key="onLista"></p-toast>
<p-dialog [(visible)]="show" position="top" modal="true" [header]="title" [breakpoints]="{'960px': '75vw', '400px': '95vw'}" [style]="{width: '50vw'}" 
    (onHide)="onHide()">
    <p-table #dt 
        [value]="items" [columns]="columns" responsiveLayout="scroll" [rows]="10" [paginator]="true" [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true"
        [lazy]="true" sortMode="multiple" [stateKey]="recordName" [loading]="loading" [totalRecords]="totalRecords" [showLoader]="false"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [(selection)]="selectedItems" selectionMode="multiple" [rowHover]="true"
        (onLazyLoad)="onItems($event)">

        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of columns" style="background-color: aliceblue;" [pSortableColumn]="col.field">{{ col.label }} <p-sortIcon [field]="col.field"></p-sortIcon></th>
            </tr>
        </ng-template>

        <ng-template pTemplate="caption">
            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                <span class="mt-2 md:mt-0 p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input [(ngModel)]="filterValue" pInputText type="text" placeholder="Buscar..." 
                        (keydown.enter)="filterData($event.target)"
                        (focusout)="filterData($event.target, true)"
                        (input)="onChangeBuscar()"/>
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr (click)="onClick(item)">
                <ng-container *ngFor="let col of columns">
                    <td *ngIf="loading">
                        <p-skeleton borderRadius="1rem"></p-skeleton>
                    </td>
                    <ng-container *ngIf="!loading">
                        <td *ngIf="col.type === 'id'" style="width:8%; min-width:8rem;">
                            <span class="p-column-title">{{ col.label }}</span>
                            {{ item[col.field] }}
                        </td>
                        <td *ngIf="col.type === 'text'">
                            <span class="p-column-title">{{ col.label }}</span>
                            {{ item[col.field] }}
                        </td>
                        <td *ngIf="col.type === 'number'">
                            <span class="p-column-title">{{ col.label }}</span>
                            {{ item[col.field] | currency: '': '': '0.0-0': 'es-PY' }}
                        </td>
                        <ng-container *ngIf="col.type === 'boolean'">
                            <td *ngIf="item[col.field] === true">
                                <i class="pi pi-check-circle" style="color: green; font-size: 1.5rem;"></i>
                            </td>
                            <td *ngIf="item[col.field] === false">
                                <i class="pi pi-times-circle" style="color: red; font-size: 1.5rem;"></i>
                            </td>
                        </ng-container>
                        <td *ngIf="col.type === 'date'">
                            <span class="p-column-title">{{ col.label }}</span>
                            {{ item[col.field] | date: 'dd/MM/yyyy' }}
                        </td>
                        <td *ngIf="col.type === 'datetime'">
                            <span class="p-column-title">{{ col.label }}</span>
                            {{ item[col.field] | date: 'dd/MM/yyyy HH:mm:ss' }}
                        </td>
                        <td *ngIf="col.type === 'multiselect'" style="width:14%; min-width: 10rem;">
                            <span class="p-column-title">{{ col.label }}</span>
                            <!-- <span [class]="'custom-badge status-' + (item.inventoryStatus ? item.inventoryStatus.toLowerCase() : '')">{{ options[col.field] }}</span> -->
                            <span [class]="'custom-badge status-qualified'">{{ getOptionLabel(col.options, item[col.field] ) }}</span>
                        </td>
                    </ng-container>
                </ng-container>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>
